export enum HelmetTypes {
    home_page = 'TVOI | Home - Срібні брендові прикраси за низькими цінами купити у Львові у Києві',
    search_page = 'Каталог: стильні ювелірні вироби, елегантні недорогі годинники, дешеві | TVOI',
    cart_page = 'Корзина: оформляй замовлення швидко, зручно та безпечно | TVOI'
}